/* eslint-disable no-unused-vars */
import service from '@/middleware'
import axios from 'axios'

const CancelToken = axios.CancelToken
export let cancelGeoData

export const geoReferenceApi = {
  async getGeoData (lat, long, radius) {
    return service.http.get(
      `/api/georeference/geo-data?lat=${lat}&long=${long}&radius=${radius}`,
      { cancelToken: new CancelToken(function executor (c) { cancelGeoData = c }) })
  }
}
